import { Typography, styled } from '@mui/material';

export default styled(Typography)({
  textAlign: 'center',
  paddingTop: ['20%', 20],
});
